import {computed, onMounted, ref, watch} from "vue";
import {useQuery, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";

const useWebsite = () => {
  const { data, refetch, isLoading } = useQuery({
    queryKey: ['current-website'],
    queryFn: () => axios.get('/ajax/v2/website'),
  });

  const website = computed(() => data.value?.data?.data);
  const websiteId = computed(() => website.value?.id);

  return {
    website,
    refetchWebsite: refetch,
    isLoading,
    websiteId,
  };
};

export default useWebsite;
